/**
 * @license jQuery v1.9.1 (c) 2005, 2012
 * jQuery Foundation, Inc. jquery.org/license.
 */

/**
 * Pattern used by plain.type to match [object XXX] strings.
 * @type {!RegExp}
 * @private
 * @const
 */
const TYPE_RE_ =
  /\[object (Boolean|Number|String|Function|Array|Date|RegExp|Arguments)\]/;

/**
 * Returns a string describing the given value's type. Same as typeof, except
 * in these cases (assuming the value's typeof() method has not been modified):
 *
 *     value         |  typeof   |  type
 *    ======================================
 *     null          |  object   |  null
 *     new Boolean() |  object   |  boolean
 *     new Number()  |  object   |  number
 *     new String()  |  object   |  string
 *     new Date()    |  object   |  date
 *     [1,2,3]       |  object   |  array
 *     /.+/          |  object   |  regexp
 *     arguments     |  object   |  arguments
 *
 * This method is also more reliable for detecting the type of objects created
 * in another window.
 *
 * @param {*} value The value to extract the type information from.
 * @return {string} The name of the given value's type.
 */
export const type = (value: unknown) => {
  if (value == null) return String(value);
  const match = TYPE_RE_.exec(Object.prototype.toString.call(Object(value)));

  if (match) return match[1].toLowerCase();

  return 'object';
};

export const isArray = (value: unknown) => type(value) === 'array';
